<template>
  <div class="plv-ia-answer-sidebar">
    <div class="plv-ia-answer-sidebar__top">
      <button class="plv-ia-btn-new plv-ia-btn-blue" :disabled="isCreating" @click="handleCreate">{{ t('plvIA.answerCard.create') }}</button>
      <button class="plv-ia-btn-new" :disabled="isCreating" @click="handleUpload">{{ t('plvIA.answerCard.import') }}</button>
    </div>
    <div class="plv-ia-answer-sidebar__middle">
      <div class="plv-ia-answer-question-list" @click="handleChange">
        <div
          v-for="item in list"
          :key="item.questionId"
          :data-id="item.questionId"
          :class="['plv-ia-answer-question-item', {
            'plv-ia-answer-question-item--active': item.questionId === curQuestionId,
            'plv-ia-answer-question-item--using': ongoingQuestionId && item.questionId === ongoingQuestionId,
            'plv-ia-answer-question-item--used': item.status === 'send' && item.questionId !== ongoingQuestionId,
          }]"
        >
          {{ item.name }}
          <span :class="getLabelCls(item)">{{ getLabel(item) }}</span>
        </div>
      </div>
    </div>
    <div class="plv-ia-answer-sidebar__bottom">
      <span class="plv-ia-btn-text" @click="handleDownload">{{ t('plvIA.answerCard.downloadTemplate') }}</span>
    </div>
  </div>
</template>

<script>
import Locale from '@/mixins/locale';

export default {
  name: 'AnswerCardSidebar',
  mixins: [Locale],
  props: {
    list: {
      type: Array,
      default: null
    },
    curQuestionId: {
      type: String,
      default: '',
    },
    ongoingQuestionId: {
      type: String,
      default: '',
    },
    curTemplateId: {
      type: String,
      default: '',
    },
    isCreating: Boolean,
  },

  methods: {
    genStatus(item) {
      // default 未发送 / send 已答题 / ongoing 答题中
      let status = item.status || 'default';
      if (item.questionId && item.questionId === this.ongoingQuestionId) {
        status = 'ongoing';
      }
      return status;
    },

    getLabel(item) {
      return {
        default: '',
        ongoing: this.t('plvIA.answerCard.statusOngoing'),
        send: this.t('plvIA.answerCard.statusTerminated'),
      }[this.genStatus(item)];
    },

    getLabelCls(item) {
      const defaultClassName = 'plv-ia-answer-nav-item__label';
      return {
        default: defaultClassName,
        ongoing: `${defaultClassName} ${defaultClassName}--ongoing`,
        send: `${defaultClassName} ${defaultClassName}--finished`,
      }[this.genStatus(item)];
    },

    handleCreate() {
      this.$emit('create');
    },

    handleUpload() {
      this.$emit('upload');
    },

    handleChange(e) {
      const questionId = e.target.getAttribute('data-id');
      if (!questionId) return;
      this.$emit('change', questionId);
    },

    handleDownload() {
      this.$emit('download', '');
    },
  }

};
</script>

<style lang="scss">
$blue: #2196F3;

.plv-ia-answer-sidebar {
  height: 100%;
  position: relative;
}
.plv-ia-answer-sidebar__top {
  position: absolute;
  width: 100%;
  box-sizing: border-box;
  top: 0;
  left: 0;
  padding: 16px 28px;
  display: flex;
  justify-content: space-between;

  .plv-ia-btn-new {
    width: 64px;
    position: relative;

    >input[type=file] {
      position: absolute;
      top: 0;
      bottom: 0;
      left: 0;
      width: 100%;
      height: 100%;
      opacity: 0;
      cursor: pointer;
    }
  }
}
.plv-ia-answer-sidebar__middle {
  height: 100%;
  box-sizing: border-box;
  padding-top: 64px;
  padding-bottom: 60px;
}

.plv-ia-answer-sidebar__bottom {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  box-sizing: border-box;
  padding: 0 26px;
  padding-bottom: 30px;
  line-height: 20px;
  display: flex;
  justify-content: space-between;
  user-select: none;

  .plv-ia-btn-text {
    text-decoration: none;
    width: 100%;
    text-align: center;
  }
}

.plv-ia-answer-question-list {
  height: 100%;
  overflow: auto;
}

.plv-ia-answer-question-item {
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  padding: 0 16px;
  line-height: 48px;
  cursor: pointer;
  user-select: none;
  position: relative;

  &--active {
    background-color: #fff;
    color: $blue;
  }
}

.plv-ia-answer-nav-item__label {
  $width: 50px;
  $height: 20px;
  $scale: 0.8; // 固定按0.8倍缩小元素

  position: absolute;
  width: $width;
  line-height: $height;
  // left: -($width - $width * $scale) / 2;
  left: -5px;
  // top: -($height - $height * $scale) / 2;
  top: -2px;
  transform: scale($scale);

  color: #fff;
  border-radius: 0 0 10px 0;
  font-size: 12px;
  padding: 0 3px;
  text-align: center;
}

.plv-ia-answer-nav-item__label--ongoing {
  background-color: #ff5631;
}

.plv-ia-answer-nav-item__label--finished {
  background-color: #2196F3;
}
</style>
